// extracted by mini-css-extract-plugin
module.exports = {"controlHolder":"SubmitPrizeSection2026_controlHolder__fg1qT","textBox":"SubmitPrizeSection2026_textBox__os4Zd"};